import BaseModelDistribution from "@/models/BaseModelDistribution.js";

export const GridConfig = {
	list: BaseModelDistribution.list,
	// columns:BaseModelDistribution.columns,	
	columns: {
		// Id: {
		// 	class: 'id',
		// 	dataName: 'Id',
		// 	type: 'number',
		// 	title: 'Id',
		// 	width: 100,
		// 	hidden: true,
		// 	readOnly: false
		// },
		PartnerId: {
			class: "lookup",
			dataName: 'PartnerId',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		PartnerPartnerID: {
			class: "lookup",
			dataName: 'Partner/PartnerID',
			type: 'string',
			title: 'Partner ID',
			width: 150,
			hidden: false,
			readOnly: true
		},
		PartnerFullName: {
			class: "lookup",
			dataName: 'Partner/FullName',
			type: 'string',
			title: 'Partner Name',
			width: 180,
			hidden: false,
			readOnly: true
		},
		// ProgramId: {
		// 	class: "lookup",
		// 	dataName: 'ProgramId',
		// 	type: 'number',
		// 	title: 'Program Id',
		// 	width: 100,
		// 	hidden: true,
		// 	readOnly: false
		// },
		// ProgramProgramID: {
		// 	class: "lookup",
		// 	dataName: 'Program/ProgramID',
		// 	type: 'string',
		// 	title: 'Program ID',
		// 	width: 150,
		// 	hidden: true,
		// 	readOnly: true
		// },
		// ProgramTitle: {
		// 	class: "lookup",
		// 	dataName: 'Program/Title',
		// 	type: 'string',
		// 	title: 'Program Name',
		// 	width: 200,
		// 	hidden: true,
		// 	readOnly: true
		// },
		DistributionType1: {
			class: "choice",
			dataName: 'DistributionType1',
			type: 'string',
			title: 'Type of Distribution 1',
			width: 230,
			hidden: false,
			readOnly: false
		},
		DistributionType2: {
			class: "choice",
			dataName: 'DistributionType2',
			type: 'string',
			title: 'Type of Distribution 2',
			width: 230,
			hidden: false,
			readOnly: false
		},
		DistributionPartnerType: {
			class: "choice",
			dataName: 'DistributionPartnerType',
			type: 'string',
			title: 'Type of Partner',
			width: 180,
			hidden: false,
			readOnly: false
		},
		DistributionDate: {
			class: 'value',
			dataName: 'DistributionDate',
			type: 'date',
			title: 'Distribution Date',
			width: 200,
			hidden: false,
			readOnly:false
		},
		DistributionAmount: {
			class: "value",
			dataName: 'DistributionAmount',
			type: 'currency',
		    title: 'Distribution Amount',
		    template: '#=kendo.toString(DistributionAmount, "c")#',
			width: 220,
			hidden: false,
			readOnly: false
		},
		// Note: {
		// 	class: 'value',
		// 	dataName: 'Note',
		// 	type: 'string',
		// 	title: 'Note',
		// 	width: 100,
		// 	hidden: true,
		// 	readOnly: false
		// }
	},
	grid: {
		gridId: 'DistributionReportGrid',
		height: 500,
		checkbox: true,
		edit: false,
		delete: false,
		document: false,
		groupable: true,
	}
}